const FormToggleInputHook = {
  mounted() {
    this.el.addEventListener('change', () => {
      if (this.el.checked) {
        liveSocket.execJS(this.el, this.el.dataset.close);
      } else {
        liveSocket.execJS(this.el, this.el.dataset.open);
      }
    });
  },
};

export default FormToggleInputHook;
